"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var axios_1 = require("axios");
var consoler_1 = require("./consoler");
exports.default = new /** @class */ (function () {
    function FileHelper() {
    }
    FileHelper.prototype.getFile = function (filePath) {
        return axios_1.default.get(filePath)
            .then(function (result) {
            return result.data;
        })
            .catch(function (error) {
            consoler_1.default.debugWarn('Failed reading file', error);
            return null;
        });
    };
    return FileHelper;
}());
